import { useState } from "react";
import imageApi from "../../api/imageLoad";
import { getCmsToken } from "../../helper/user";
import { errorMsg } from "helper/message";

const useGetImage = () => {
  const [urlImage, setUrlImage] = useState(null);
  const [loadingImage, setLoadingImage] = useState(false);
  const tokenAccess = getCmsToken();

  const handleGetUrlImage = async (url) => {
    try {
      setLoadingImage(true);
      setUrlImage(null);
      const res = await imageApi({
        method: "get",
        url,
        headers: { Authorization: `Bearer ${tokenAccess?.access_token}` },
        responseType: "blob",
      });
      await setUrlImage(URL.createObjectURL(res?.data) ?? "");
      setLoadingImage(false);
    } catch (err) {
      setUrlImage(null);
      errorMsg(err);
      setLoadingImage(false);
    }
  };
  return { urlImage, handleGetUrlImage, loadingImage };
};

export default useGetImage;
